import { AxiosPromise } from 'axios'

import http from './http'
import { AppApiResponseData } from '../types/api'
import { UserOrganizationEducationalContent } from '../types/user'

function getEducationModules():
	AxiosPromise<AppApiResponseData<UserOrganizationEducationalContent[]>>
{
	return http({
		method: 'GET',
		url: '/p/educationalContentModules'
	})
}

export { getEducationModules }
